export enum MarkerTypeTooltip {
  TEXT = 'mu-map-tooltip-text',
  TEXT_ICON = 'mu-map-tooltip-text-icon',
  TEXT_LARGE_ICON = 'mu-map-tooltip-text-icon mu-text-large',
  NUMBER = 'mu-map-tooltip-number',
}
